import { TFunction } from 'i18next';

import {
  OPPORTUNITY,
  PRELIMINARY_OFFER,
} from 'services/enums/offers/offerTypes';

/**
 * Translation path of the statuses of an offer. Approving a preliminary offer converts it
 * to an offer, so its "approved" status reads "Convert to offer" as a choice and
 * "Converted to offer" once done, instead of "Approved".
 */
export const getStatusTranslationPath = (
  offerType: string | undefined,
  done: boolean
): string => {
  // The closing of an opportunity reads e.g. "Convert to offer" as a choice and
  // "Converted to offer" once done
  if (offerType === OPPORTUNITY) {
    return done
      ? 'offers:opportunityStatusesDone'
      : 'offers:opportunityStatuses';
  }

  if (offerType !== PRELIMINARY_OFFER) {
    return 'offers:statuses';
  }

  return done ? 'offers:preliminaryStatusesDone' : 'offers:preliminaryStatuses';
};

/**
 * Status of an offer as shown in lists, i.e. as something that has happened.
 */
const getOfferStatusLabel = (
  t: TFunction,
  status: string,
  offerType: string | undefined
): string => t(`${getStatusTranslationPath(offerType, true)}.${status}`);

export default getOfferStatusLabel;
